<template>
  <modal :modal-key="'daily-bonus-spin_wheel_modal'"
         @close="$emit('close')"
         class="modal--welcomeback no_space"
         :body-style="'achievement'">
    <template slot="header">
      <h1>{{ getTranslations.home_bonus_header }}</h1>
      <h1>{{ getTranslations.home_bonus_you_won }} {{ quantity }} {{ getTranslations.home_bonus_spinning_wheel }}</h1>
    </template>
    <template slot="body">
      <div class="daily_bonus_selected prize">
        <div class="bounce_box bounce_animation">
          <img class="icon" src="static/images/wheel.svg" alt="">
        </div>
        <a href="#"
           @click.prevent="spin()"
           class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_bonus_button_procced }}
        </a>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import SpinWheel from '@/components/home/modals/achievements/SpinWheel';

export default {
  name: 'daily-bonus-spin-wheel',
  components: {
    Modal,
    SpinWheel,
  },
  beforeDestroy() {
    this.closeModal();
  },
  data() {
    return {
      quantity: 1,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'clearBonusDailyModal',
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationId',
    ]),
    spin() {
      const { spinningPrizeDesc, spinningPrizeWon, id } = this.bonusDailyModal;

      const spinNotification = (this.notifications || []).filter(notification => notification.gameId === parseInt(id, 10))[0];

      this.setCheckedNotificationId({ value: spinNotification.id });
      this.setNotificationRewardId({ value: id });
      this.setNotificationRewardName({ value: spinningPrizeDesc });
      this.setNotificationPrizeWon({ value: spinningPrizeWon });
      this.storeModalForHomePage(SpinWheel);
    },
    closeModal() {
      this.clearBonusDailyModal();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'notifications',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/daily_bonus_modals/DailyBonusSpinningWheel.vue